import { render, staticRenderFns } from "./HeaderProfitabilityAnalysis.vue?vue&type=template&id=2ea6dc8c&scoped=true"
import script from "./HeaderProfitabilityAnalysis.vue?vue&type=script&lang=js"
export * from "./HeaderProfitabilityAnalysis.vue?vue&type=script&lang=js"
import style0 from "./HeaderProfitabilityAnalysis.vue?vue&type=style&index=0&id=2ea6dc8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea6dc8c",
  null
  
)

export default component.exports